import React from 'react';
import { SearchBox } from 'react-instantsearch-dom';
import Icon from '../../3-components/Icon/Icon';

interface AlgoliaSearchInputProps {
    defaultRefinement?: string;
    placeholder?: string;
}

const AlgoliaSearchInput = ({ placeholder, defaultRefinement }: AlgoliaSearchInputProps) => (
    <SearchBox
        submit={<Icon icon="search" />}
        reset={<Icon icon="remove" />}
        translations={{ placeholder: `${placeholder ? placeholder : ''}` }}
        defaultRefinement={defaultRefinement}
    />
);

export default AlgoliaSearchInput;
